<template>
  <section class='content'>
    <edit-modal :addressForComp="editAddress" @alert="alert($event)" :mode="'shipping'" :line="lineForEdit"></edit-modal>
    <div class="modal fade" id="payload-modal" tabindex="-1" role="dialog" aria-labelledby="payloadModalLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-database mr-5"></i>Information</h4>
          </div>
          <div class="modal-body">
            <p><strong>Payload:</strong><br/> <pre>{{selectedPayload}}</pre></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline" data-dismiss="modal"><span class="fa fa-times mr-5"></span>Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="box box-danger box-solid">
          <div class="box-header with-border">
            <h3 class="box-title"><i class="fa fa-exclamation-triangle mr-5"></i>{{'label_errors' | translate}}</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
              <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
            </div>
          </div>
          <div class="box-body">
            <template v-if="loading">
              <div>
                <img class="loading-gif" src="/static/img/blabla.svg"/>
              </div>
            </template>
            <template v-else>
              <div class="table-responsive" v-if="labels.length > 0">
                <div class="col-12 text-right danger">
                  <button class="btn btn-info" @click="bulkUpdateLabels()"><i class="fa fa-refresh"></i> Alle Labels neu erstellen</button>
                </div>
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>{{'go_to_order' | translate}}</th>
                    <th>{{'date' | translate}}</th>
                    <th>{{'information' | translate}}</th>
                    <th>{{'status' | translate}}</th>
                    <th class="text-center">{{'retry_label' | translate}}</th>
                    <th class="text-center">{{'address' | translate}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(label, index) in labels">
                    <label-row v-if="label.show" :label="label" :index="index" :messages="messages[index]" @remove="removeLine($event)" @correct="pepe($event)" @payload="openPayload($event)"></label-row>
                  </template>
                  </tbody>
                </table>
              </div>
              <div v-else>
                Keine fehler
              </div>
            </template>
          </div>
          <div class="box-footer"></div>
        </div>
      </div>
    </div>
    <a hidden href="#" id ="openModal" data-toggle="modal" data-target="#edit-modal"></a>
    <a hidden href="#" id ="openPayload" data-toggle="modal" data-target="#payload-modal"></a>
  </section>
</template>
<script>
export default {
  data () {
    return {
      orders: {},
      messages: [],
      loading: true,
      selectedPayload: '',
      cancelReason: 'out_of_stock',
      lineForCancel: 0,
      lineForEdit: 0,
      labels: [],
      query: '',
      alerts: [],
      information: {
        message: {
        },
        payload: {
        }
      },
      editOrderId: '',
      editAddress: {
        corrected_company: '',
        corrected_first_name: '',
        corrected_last_name: '',
        corrected_zip: '',
        corrected_city: '',
        corrected_street: '',
        corrected_street_number: '',
        corrected_care_of: ''
      }
    }
  },
  methods: {
    update (value) {
      this.query = value
    },
    notify (value) {
      this.$store.commit('pushAlert', {dismiss: 4, type: value[0], message: value[1], icon: value[2], show: true})
    },
    selectEvent (value) {
      this.information = ''
      this.information = value
    },
    openCancelModal (line) {
      this.lineForCancel = line
    },
    cancelOrder (reason) {
      API.put(`orders/line/${this.lineForCancel}/cancel`, {reason: reason})
        .then(response => {
          $('#cancelModal').click()
          API.get('monitoring/order/failed', {})
            .then(response => {
              this.orders = response.data.result
            })
        })
    },
    bulkUpdateLabels() {
      this.loading = true
      API.put('monitoring/labels/failed')
        .then(response => {
          setTimeout(() => {
            this.getErrorLabels()
          }, 10000);
        }).catch(error => {
          this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error, icon: 'fa fa-ban', show: true})
        })
    },
    pepe (event) {
      this.editAddress = event.data
      this.editOrderId = event.id
      this.lineForEdit = event.id
      $('#openModal').click()
    },
    removeLine (event) {
      this.labels[this.labels.indexOf(event)].show = false
    },
    openPayload (event) {
      this.selectedPayload = event
      $('#openPayload').click()
    },
    getErrorLabels() {
      this.messages = []
      API.get('monitoring/labels/failed', {})
        .then(response => {
          response.data.forEach(l => {
            l.show = true
            if (l.message.substr(0,1) === '{') {
              let messages = JSON.parse(l.message)
              let aux = []
              for (let x in messages.errors) {
                aux.push(messages.errors[x])
              }
              this.messages.push(aux)
            } else {
              this.messages.push([l.message])
            }
          })
          this.labels = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('pushAlert', {dismiss: 4, type: 'danger', message: error, icon: 'fa fa-ban', show: true})
        })
    }
  },
  mounted () {
    this.getErrorLabels()
  }
}
</script>
<style scoped>
  pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
  }
  .loading-gif {
    max-width: 345px;
    margin-left: 42%;
  }
</style>




// WEBPACK FOOTER //
// src/components/views/Monitoring/Labels.vue